import type { TestResult } from 'v2/interfaces/webhook2';

import { apiServiceProxy } from './api-proxy';

class DeliveryProvidersService {
  public customTestUrl(url: string): Promise<TestResult> {
    return apiServiceProxy.post('/deliveryproviders/custom/test-url', { url }).then((response) => response.data);
  }
  public leadloversTestUrl(url: string): Promise<TestResult> {
    return apiServiceProxy.post('/deliveryproviders/leadlovers/test-url', { url }).then((response) => response.data);
  }
  public apolloTestUrl(url: string): Promise<TestResult> {
    return apiServiceProxy.post('/deliveryproviders/apollo/test-url', { url }).then((response) => response.data);
  }
}

const deliveryProvidersService = new DeliveryProvidersService();
export default deliveryProvidersService;
